import { render, staticRenderFns } from "./PasswordSetting.vue?vue&type=template&id=b437bfe6&"
import script from "./PasswordSetting.vue?vue&type=script&lang=js&"
export * from "./PasswordSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports